import React, { useEffect, useState, useRef } from "react";
import { Card, Form, Image, List, Modal, Space } from "antd";
import { useHistory } from "react-router-dom";
import { BASE_API_CONFIG } from "util/Api";
import { LeftOutlined } from "@ant-design/icons";
import { Row, Col, Button } from "antd";
import { axiosInstance } from "util/Api";
import { EnquiryStatus } from "util/Constant";
import { isLessThan24Hrs } from "util/helper";
import EnquiryStatusTags from "./EnquiriesStatus";
import {
  isArrayNonEmpty,
  isValidString,
  safeStringValue,
} from "../../util/ApiHelper";
import moment from "moment";
import TextArea from "antd/lib/input/TextArea";
import Messages from "../messages";
import { useDispatch } from "react-redux";
import { getMessagesAction } from "../../appRedux/actions/requestQuotationAction";
import { useGetBreakpoints } from "../../hooks/useGetBreakpoints";
import { isCHA } from "../../util/helper";
import { useSelector } from "react-redux";
import {
  isCustomhouseagentsCumFreightforwarder,
  isFreightForwarder,
} from "../../util/helper";

const QuotationsSubmitDetails = ({ quotationData, onNext }) => {
  const history = useHistory();
  const { isMobile } = useGetBreakpoints();
  const [fileName, setFileName] = useState("");
  console.log(quotationData);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [messageSubmit, setMessageSubmit] = useState(false);
  const dispatch = useDispatch();
  
  // Add ref for Messages component to focus chat input
  const messagesRef = useRef();

  const [form] = Form.useForm();

  const { status, price, units, description, expiryDate, currencyCode, id } =
    quotationData?.data?.data ?? {};
  const formattedexpiryDate = moment(expiryDate).format("DD-MM-YYYY");
  const authUser = useSelector(({ auth }) => auth.userData);
  const isPureFreightForwarder =
    isFreightForwarder(authUser) &&
    !isCustomhouseagentsCumFreightforwarder(authUser);

  useEffect(
    () => {
      if (isArrayNonEmpty(quotationData?.data?.data.attachments)) {
        const fileNames = quotationData?.data?.data.attachments?.map(
          (image) => {
            return image;
          }
        );
        setFileName(fileNames);
      }
      if (messageSubmit) {
        setMessageSubmit(false);
      }
    },
    [quotationData],
    [messageSubmit]
  );

  const { shipmentMode, shipmentType, containerType } =
    quotationData?.data?.data?.enquiries ?? {};

  const onSubmit = async () => {
    let data = {
      id: id,
      enquiryId: quotationData?.data?.data.enquiryId,
      receiverId: quotationData?.data?.data.receiverId,
      senderId: quotationData?.data?.data.senderId,
      status: EnquiryStatus.ORDER_CONFIRMED,
    };
    const response = await axiosInstance.post(
      `${BASE_API_CONFIG.baseURL}/quotations/` + id,
      data
    );
    if (response.status === 200) {
      history.goBack();
    }
  };

  const getStatus = (record) => {
    let status = record?.readReciept[0]?.status;
    if (!status) {
      status = isLessThan24Hrs(record?.createdAt)
        ? EnquiryStatus.NEW_ENQUIRY
        : EnquiryStatus.AWAITING_FOR_QUOTATION;
    }
    return <EnquiryStatusTags status={status} />;
  };
  const navigateBusinessCard = (id) => {
    if (id) {
      history.push(`/user-profile?id=${id}`);
    }
  };

  const data = [
    ...(isPureFreightForwarder ? [{
      label: "Company Name",
      value: (
        <div>
          <div>{quotationData?.data?.data?.receiver?.companyName || quotationData?.data?.data?.enquiries?.user?.companyName || "-"}</div>
          <div
            onClick={() =>
              navigateBusinessCard(
                quotationData?.data?.data?.receiverId ||
                  quotationData?.data?.data?.enquiries?.user?.id
              )
            }
            style={{
              color: "#1890ff",
              cursor: "pointer",
              textDecoration: "underline",
              marginTop: 4,
              display: "inline-block",
            }}
          >
            View Profile
          </div>
        </div>
      ),
    }] : []),
    ...(!isCHA(authUser)
      ? [
          {
            label: "Price",
            value: `${safeStringValue(currencyCode)} ${safeStringValue(
              price
            )} / ${safeStringValue(
              units,
              shipmentMode === "sea"
                ? shipmentType === "fcl"
                  ? `Unit (${containerType})`
                  : "Cubic Meter"
                : "Cubic Meter"
            )}`,
          },
        ]
      : []),
    ...(!isCHA(authUser)
      ? [
          {
            label: "Quotation Expiry date",
            value: formattedexpiryDate || "--",
          },
        ]
      : []),
    {
      label: "Response Message",
      value: description,
    },
    {
      label: "Status",
      value: getStatus(quotationData?.data?.data),
    },
  ];

  // Function to handle focusing the chat input in Messages component
  const handleSendMessageClick = () => {
    // Focus the chat input in Messages component
    if (messagesRef.current) {
      messagesRef.current.focusChatInput();
      
      // Optional: Scroll to Messages component
      messagesRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  // Remove modal functions since we're not using modal anymore
  // const showModal = () => {
  //   setIsModalOpen(true);
  // };
  // const handleOk = () => { ... };
  // const handleCancel = () => { ... };

  return (
    <>
      <Card className="myexim-detail-card">
        <div className="myexim-table-title">
          <LeftOutlined
            className={"back-icon"}
            size="large"
            onClick={() => {
              history.goBack();
            }}
          />
          Quotation Details
        </div>
        <List
          className="gx-mt-4"
          itemLayout="horizontal"
          dataSource={data}
          renderItem={(item) =>
            item?.value && (
              <List.Item className="myexim-details-list">
                <List.Item.Meta
                  title={<div>{item.label}</div>}
                  description={item.value}
                />
              </List.Item>
            )
          }
        />
        {fileName?.length > 0 && (
          <div className="attachments">
            <div className="sub-header">Attachments</div>
            <div className="gx-pt-4">
              {fileName?.map((fileName, index) => (
                <div key={index} className="gx-pb-3">
                  <Image width={150} height={150} src={fileName?.src} />
                </div>
              ))}
            </div>
          </div>
        )}
        <Row
          className="gx-mt-3 gx-mr-1"
          style={{
            textAlign: "right",
            justifyContent: isMobile ? "center" : "end",
            display: "flex",
            flex: 1,
          }}
        >
          <Space>
            <Col>
              <Button size="large" type="primary" onClick={handleSendMessageClick}>
                Send Message
              </Button>
            </Col>
            {status === EnquiryStatus.ORDER_PLACED && (
              <Col>
                <Button
                  type="primary"
                  size="large"
                  htmlType="submit"
                  className={"submit-btn"}
                  onClick={() => onSubmit()}
                >
                  Confirm Order
                </Button>
              </Col>
            )}
          </Space>
        </Row>
      </Card>
      
      {/* Add a div wrapper with ref for scrolling */}
      

       <Messages
      ref={messagesRef}
      id={quotationData?.data?.data?.id}
      loggedInUserId={quotationData?.data?.data?.senderId}
      isQuotation={true}
      receiverId={quotationData?.data?.data?.receiverId}
      receiverName={quotationData?.data?.data?.receiver?.name}
      quotationDetails={quotationData?.data?.data}
    />
      
      {/* Remove Modal since we're not using it */}


    </>
  );
};

export default QuotationsSubmitDetails;
